import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { saveBintiTags } from "../services/soar";
import CaseNoteDisplay from "./CaseNoteDisplay";
import HomeApplicants from "./HomeApplicants";
import HomeButtonBar from "./HomeButtonBar";

function DynamicHome({ application, availableTags, refreshData }) {
  const [isOpen, setIsOpen] = useState(false);
  const [tagData, setTagData] = useState(
    application.HomeData[0].tags.map((t) => ({ tag: t, action: "current" }))
  );
  const calculateDays = (d) => {
    const days =
      Math.ceil(
        (new Date().getTime() - new Date(d.replaceAll("-", "/")).getTime()) /
          (1000 * 3600 * 24)
      ) - 1;
    return days;
  };

  const saveTags = () => {
    if (
      process.env.REACT_APP_ENVIRONMENT === "Production" ||
      application.id === "384446-1" ||
      application.id === "381389"
    ) {
      const toastId = toast.loading("Writing Tags to Binti", {
        type: toast.TYPE.INFO,
      });

      handleSave(toastId);
    } else {
      toast.success("This would have edited the tags in Binti");
    }
  };

  const handleSave = (toastId) => {
    const tagsToAdd = tagData.filter((t) => t.action === "add");
    const tagsToRemove = tagData.filter((t) => t.action === "removeCurrent");

    let obj = {
      data: [],
    };

    if (tagsToRemove.length > 0) {
      obj.data.push({
        id: application.HomeData[0].applicationid,
        action: "delete",
        tags: tagsToRemove.map((t) => t.tag),
      });
    }
    if (tagsToAdd.length > 0) {
      obj.data.push({
        id: application.HomeData[0].applicationid,
        action: "add",
        tags: tagsToAdd.map((t) => t.tag),
      });
    }
    console.log("Tag Object", obj);
    if (tagsToAdd.length > 0 || tagsToRemove.length > 0) {
      saveBintiTags(application.HomeData[0].company, obj).then((response) => {
        const tagResponse = JSON.parse(response);
        console.log("Tag Edit Response", tagResponse);
        if (tagResponse.SystemResponse[0]?.Code === "success") {
          toast.update(toastId, {
            render: tagResponse.SystemResponse[0].Message,
            type: toast.TYPE.SUCCESS,
            isLoading: false,
            autoClose: 5000,
            closeOnClick: true,
          });
          refreshData();
        } else {
          toast.update(toastId, {
            render: `Tag Edit failed with the message ${tagResponse.SystemResponse[0].Message}}`,
            type: toast.TYPE.ERROR,
            isLoading: false,
            autoClose: 5000,
            closeOnClick: true,
          });
        }
      });
    } else {
      toast.update(toastId, {
        render: `No Tags to Edit for ${application.HomeData[0].fostercarehomename}`,
        type: toast.TYPE.SUCCESS,
        isLoading: false,
        autoClose: 5000,
        closeOnClick: true,
      });
    }
    setTagData(
      application.HomeData[0].tags.map((t) => ({
        tag: t,
        action: "current",
      }))
    );
    setIsOpen(false);
  };

  const approvalStyle = (appId) => {
    let style = "rounded ps-2 py-1";
    const eta = appId.HomeData[0].approval_date_estimate[0]?.case_note_date
      ? new Date(
          appId.HomeData[0].approval_date_estimate[0].case_note_date.replaceAll(
            "-",
            "/"
          )
        ).toLocaleDateString("en-us")
      : null;
    if (eta) {
      const today = new Date().toLocaleDateString("en-us");
      const diffInDays = Math.ceil(
        (new Date(eta) - new Date(today)) / (1000 * 3600 * 24)
      );
      console.log(diffInDays);
      if (0 > diffInDays) {
        console.log("Hit Past Due");
        style += " bg-danger text-white";
      } else if (10 > diffInDays) {
        style += " bg-warning text-dark";
      } else if (diffInDays >= 10) {
        style += " bg-success text-white";
      }
    }

    return style;
  };

  return (
    <>
      <Modal
        show={isOpen}
        animation={false}
        onHide={() => {
          setTagData(
            application.HomeData[0].tags.map((t) => ({
              tag: t,
              action: "current",
            }))
          );
          setIsOpen(false);
        }}
        size="lg"
      >
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>
            {application.HomeData[0].fostercarehomename} Tags
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row h5 mb-2 ms-2">Tags</div>
          {tagData.map((t, index) => (
            <div key={`${t.tag}${index}`} className="d-inline-block">
              {t.action === "current" && (
                <div
                  className="btn btn-secondary m-2 p-2"
                  onClick={() => {
                    let obj = [...tagData];
                    obj[index].action = "removeCurrent";
                    setTagData(obj);
                  }}
                >
                  {t.tag}
                  <i className="fas fa-circle-minus ms-2"></i>
                </div>
              )}
              {t.action === "removeCurrent" && (
                <div
                  className="btn btn-danger m-2 p-2"
                  onClick={() => {
                    let obj = [...tagData];
                    obj[index].action = "current";
                    setTagData(obj);
                  }}
                >
                  {t.tag}
                  <i className="fas fa-circle-plus ms-2"></i>
                </div>
              )}
              {t.action === "add" && (
                <div
                  className="btn btn-success m-2 p-2"
                  onClick={() => {
                    let obj = [...tagData];
                    obj.splice(index, 1);
                    setTagData(obj);
                  }}
                >
                  {t.tag}
                  <i className="fas fa-circle-minus ms-2"></i>
                </div>
              )}
            </div>
          ))}
          <div className="border rounded mt-4">
            <div className="row h5 mb-2 mt-2 ms-2">Available Tags</div>
            {availableTags
              .filter((at) => !tagData.map((td) => td.tag).includes(at))
              .map((t, index) => (
                <div
                  key={`a${t}${index}`}
                  className="btn btn-primary m-2 p-2"
                  onClick={() => {
                    let obj = [...tagData];
                    obj.push({ tag: t, action: "add" });
                    setTagData(obj);
                  }}
                >
                  {t}
                  <i className="fas fa-circle-plus ms-2"></i>
                </div>
              ))}
          </div>
          <div className="row mt-4">
            <div className="col-2">
              <div className="btn btn-success" onClick={() => saveTags()}>
                Save
              </div>
            </div>
            <div className="col-8"></div>
            <div className="col-2">
              <div
                className="btn btn-danger"
                onClick={() => {
                  setTagData(
                    application.HomeData[0].tags.map((t) => ({
                      tag: t,
                      action: "current",
                    }))
                  );
                  setIsOpen(false);
                }}
              >
                Cancel
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <div
        className="row border mb-2 p-2"
        style={
          application.HomeData.length > 0 &&
          (application.HomeData[0].status === "recruiting" ||
            application.HomeData[0].status === "applying" ||
            application.HomeData[0].status === "approved")
            ? null
            : { backgroundColor: "#DDD" }
        }
      >
        <div className="row">
          <div className="col-12 col-md-1 text-safy-info mb-2 mb-md-0">
            <HomeButtonBar application={application} />
          </div>
          <div className="col-12 col-md-3 mb-3 mb-md-0">
            <div className="fw-bold">Applicants</div>
            <HomeApplicants application={application} />
            <div className="fw-bold mt-2">Workers</div>
            <div className="text-break">
              {application.HomeData[0] &&
                application.HomeData[0].workers &&
                application.HomeData[0].workers.map(
                  (w) => `${w.worker_name}, `
                )}
            </div>
          </div>
          {application.HomeData[0]?.status === "recruiting" && (
            <>
              <div className="col-12 col-md-3 mb-3 mb-md-0">
                <div className="fw-bold">Days in Recruiting</div>
                {application.HomeData.length > 0
                  ? `${calculateDays(
                      application.HomeData[0].inquirydate
                    )} days since inquiry`
                  : ""}
                <div className="mt-2">
                  {application.HomeData[0] &&
                  application.HomeData[0].approval_date_estimate &&
                  application.HomeData[0].approval_date_estimate.length > 0 ? (
                    <>
                      <div className="fw-bold">Approval Date Est:</div>
                      <div>
                        {new Date(
                          application.HomeData[0].approval_date_estimate[0].case_note_date.replaceAll(
                            "-",
                            "/"
                          )
                        ).toLocaleDateString("en-us")}
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-12 col-md-3 mb-3 mb-md-0">
                <div className="fw-bold">Days Since</div>
                {application.HomeData.length > 0 &&
                application.HomeData[0].info_session &&
                application.HomeData[0].info_session.length > 0 &&
                application.HomeData[0].info_session[0].training_date ? (
                  <div>{`Info Session: ${calculateDays(
                    application.HomeData[0].info_session[0].training_date
                  )}`}</div>
                ) : (
                  <div className="text-danger fw-bold">
                    Info Session Not Attended
                  </div>
                )}
                {application.HomeData[0] &&
                application.HomeData[0].last_attended_training &&
                application.HomeData[0].last_attended_training.length > 0 ? (
                  <div>
                    <div>{`Attended Training: ${calculateDays(
                      application.HomeData[0].last_attended_training[0]
                        .training_date
                    )}`}</div>
                    <div className="text-break">{`${application.HomeData[0].last_attended_training[0]["training-title"]} (${application.HomeData[0].last_attended_training[0].status})`}</div>
                  </div>
                ) : (
                  <div className="text-danger fw-bold">
                    No Trainings Attended
                  </div>
                )}
                {application.HomeData.length > 0 &&
                application.HomeData[0].applicationsigneddate &&
                application.HomeData[0].applicationsigneddate !== "" ? (
                  <div>{`Application Signed: ${calculateDays(
                    application.HomeData[0].applicationsigneddate
                  )}`}</div>
                ) : (
                  <div className="text-danger fw-bold">
                    Application Not Signed
                  </div>
                )}
              </div>
            </>
          )}
          {application.HomeData[0]?.status === "applying" &&
            application.HomeData[0]?.type !== "RenewalApplication" && (
              <>
                <div className="col-12 col-md-3 mb-3 mb-md-0">
                  <div className="fw-bold">Days Since</div>
                  <div>
                    {application.HomeData[0].statusdate &&
                    application.HomeData[0].statusdate !== "" &&
                    application.HomeData[0].statusdate !== "0001-01-01"
                      ? `Applying Status: ${calculateDays(
                          application.HomeData[0].statusdate
                        )}`
                      : `Applying Status:`}
                  </div>
                  {application.HomeData[0] &&
                  application.HomeData[0].last_attended_training &&
                  application.HomeData[0].last_attended_training.length > 0 ? (
                    <div>
                      <div>{`Attended Training: ${calculateDays(
                        application.HomeData[0].last_attended_training[0]
                          .training_date
                      )}`}</div>
                      <div className="text-break">{`${application.HomeData[0].last_attended_training[0]["training-title"]} (${application.HomeData[0].last_attended_training[0].status})`}</div>
                    </div>
                  ) : (
                    <div className="text-danger fw-bold">
                      No Trainings Attended
                    </div>
                  )}
                  {application.HomeData.length > 0 &&
                  application.HomeData[0].applicationsigneddate &&
                  application.HomeData[0].applicationsigneddate !== "" ? (
                    <div>{`Application Signed: ${calculateDays(
                      application.HomeData[0].applicationsigneddate
                    )}`}</div>
                  ) : (
                    <div className="text-danger fw-bold">
                      Application Not Signed
                    </div>
                  )}
                </div>
                <div className="col-12 col-md-3 mb-3 mb-md-0">
                  <div className="fw-bold">Completion</div>
                  <div>
                    {application.HomeData[0] &&
                    application.HomeData[0].formscompletedpercentage
                      ? `Forms: ${application.HomeData[0].formscompletedpercentage}%`
                      : ""}
                  </div>
                  <div>
                    {application.HomeData[0] &&
                    application.HomeData[0].supportingdocscompletedpercentage
                      ? `Documents: ${application.HomeData[0].supportingdocscompletedpercentage}%`
                      : ""}
                  </div>
                  <div className={approvalStyle(application)}>
                    {application.HomeData[0] &&
                    application.HomeData[0].approval_date_estimate &&
                    application.HomeData[0].approval_date_estimate.length >
                      0 ? (
                      `Approval Date Est: ${new Date(
                        application.HomeData[0].approval_date_estimate[0].case_note_date.replaceAll(
                          "-",
                          "/"
                        )
                      ).toLocaleDateString("en-us")}`
                    ) : (
                      <div className="h6 text-danger">
                        NO APPROVAL DATE ESTIMATE
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          {application.HomeData[0]?.status === "applying" &&
            application.HomeData[0]?.type === "RenewalApplication" && (
              <>
                <div className="col-12 col-md-3 mb-3 mb-md-0">
                  <div className="fw-bold text-break">{application.id}</div>
                  <div className="fw-bold">
                    Renewal Date
                    {application.HomeData.length > 0 &&
                      ` ${new Date(
                        application.HomeData[0].renewaldate
                      ).toLocaleDateString()}`}
                  </div>
                </div>
                <div className="col-12 col-md-3 mb-3 mb-md-0">
                  <>
                    <div>{`Capacity: ${application.HomeData[0].capacity}`}</div>
                    <div>{`Ages: ${application.HomeData[0].approvedagelower}-${application.HomeData[0].approvedagehigher}`}</div>
                  </>
                </div>
              </>
            )}

          {application.HomeData[0]?.status === "closed" && (
            <>
              <div className="col-12 col-md-3 mb-3 mb-md-0">
                <div className="fw-bold text-break">{application.id}</div>
              </div>
              <div className="col-12 col-md-3 mb-3 mb-md-0">
                <div>{`Binti Close Date ${new Date(
                  application.HomeData[0].statusdate.replaceAll("-", "/")
                ).toLocaleDateString("en-us")}`}</div>
              </div>
            </>
          )}

          {application.HomeData[0]?.status !== "recruiting" &&
            application.HomeData[0]?.status !== "applying" &&
            application.HomeData[0]?.status !== "approved" &&
            application.HomeData[0]?.status !== "closed" && (
              <>
                <div className="col-12 col-md-3 mb-3 mb-md-0">
                  <div className="fw-bold text-break">{application.id}</div>
                </div>
                <div className="col-12 col-md-3 mb-3 mb-md-0">
                  <div>{`Binti Status ${application.HomeData[0].status.replaceAll(
                    "_",
                    " "
                  )}`}</div>
                </div>
              </>
            )}

          <div className="col-12 col-md-2 mb-2 mb-md-0">
            <div className="fw-bold">Contact Dates</div>
            {application.HomeData[0] &&
            application.HomeData[0].last_contact.length > 0 ? (
              <CaseNoteDisplay
                application={application}
                caseNoteId={
                  application.HomeData[0].last_contact[0].case_note_id
                }
                label="Last: "
                caseNoteDate={
                  application.HomeData[0].last_contact[0].case_note_date
                }
              />
            ) : (
              <div className="text-danger fw-bold">Last: None</div>
            )}
            {application.HomeData[0] &&
            application.HomeData[0].next_contact.length > 0 ? (
              <CaseNoteDisplay
                application={application}
                caseNoteId={
                  application.HomeData[0].next_contact[0].case_note_id
                }
                label="Next: "
                caseNoteDate={
                  application.HomeData[0].next_contact[0].case_note_date
                }
              />
            ) : (
              <div className="text-danger fw-bold">Next: None</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-12 mt-2">
          <div className="d-flex flex-wrap align-items-center gap-1">
            <div className="me-2">
              <small>Tags:</small>
            </div>
            {application.HomeData[0] &&
            application.HomeData[0].tags.length === 0 ? (
              <div
                className="btn btn-sm btn-warning"
                onClick={() => setIsOpen(true)}
              >
                Add Tags <i className="fas fa-plus ms-1"></i>
              </div>
            ) : (
              <>
                {application.HomeData[0].tags.map(
                  (tg, idx) =>
                    tg !== "" && (
                      <div
                        key={`tag_${tg}_${idx}`}
                        className="badge rounded bg-primary text-white py-1 px-2 me-1 mb-1"
                      >
                        {tg}
                      </div>
                    )
                )}
                <div
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => setIsOpen(true)}
                >
                  <i className="fas fa-pencil-alt"></i>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default DynamicHome;
